import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

/** Lightweight fallback for auth route transitions — avoids AppBootLoader. */
export default function AuthRouteFallback() {
  return (
    <Box
      sx={{
        minHeight: { xs: '60vh', md: '75vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        p: { xs: 2, md: 4 },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 480,
          bgcolor: '#fff',
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          p: { xs: 3, sm: 4 },
        }}
      >
        <Stack spacing={2}>
          <Skeleton variant="rounded" height={48} animation="wave" />
          <Skeleton variant="text" width="55%" height={28} animation="wave" sx={{ mx: 'auto' }} />
          <Skeleton variant="rounded" height={52} animation="wave" />
          <Skeleton variant="rounded" height={52} animation="wave" />
          <Skeleton variant="rounded" height={48} animation="wave" />
        </Stack>
      </Box>
    </Box>
  )
}
